import HomeIcon from '@/assets/img/svg/icons/home.svg?component'
import Logout from '@/assets/img/svg/icons/logout.svg?component'
import type { SidebarConfig } from '@ai/ui-components'
import { useAnalytics } from '@/composables/analytics/useAnalytics'

const logout = async () => {
  try {
    const { reset } = useAnalytics()
    reset()

    const response = await fetch('/auth/logout', {
      method: 'GET',
      credentials: 'include',
      redirect: 'manual',
    })
    const redirectUrl = response.headers.get('location')
    if (redirectUrl) {
      window.location.assign(redirectUrl)
      return
    }
    if (response.redirected && response.url) {
      window.location.assign(response.url)
      return
    }
  } catch (error) {
    console.error('Logout failed:', error)
  }
}

export const SIDEBAR_CONFIG: SidebarConfig = [
  {
    key: 'home',
    type: 'static',
    items: [
      {
        key: 'home',
        path: '',
        labelKey: 'navigation.home',
        icon: { kind: 'component', component: HomeIcon },
      },
    ],
  },
  {
    key: 'build',
    type: 'collapsible',
    labelKey: 'navigation.build',
    icon: { kind: 'uiicon', name: 'artificial-intelligence', variant: 'solid', size: 'l' },
    items: [
      { key: 'virtual-agents', path: 'virtual-agents', labelKey: 'navigation.virtual_agents' },
      { key: 'knowledge', path: 'knowledge', labelKey: 'navigation.knowledge' },
      { key: 'fine-tuning', path: 'fine-tuning', labelKey: 'navigation.fine_tuning' },
      { key: 'variables', path: 'variables', labelKey: 'navigation.variables' },
    ],
  },
  {
    key: 'monitor',
    type: 'collapsible',
    labelKey: 'navigation.monitor',
    icon: { kind: 'uiicon', name: 'desktop', variant: 'outline', size: 'l' },
    items: [
      {
        key: 'live-supervision',
        path: 'live-supervision',
        labelKey: 'navigation.live_supervision',
      },
      { key: 'cold-monitoring', path: 'cold-monitoring', labelKey: 'navigation.cold_monitoring' },
    ],
  },
  {
    key: 'organization',
    type: 'collapsible',
    labelKey: 'navigation.organization',
    icon: { kind: 'uiicon', name: 'users', variant: 'outline', size: 'l' },
    items: [{ key: 'users', path: 'users', labelKey: 'navigation.users' }],
  },
  {
    key: 'footer',
    type: 'footer',
    labelKey: 'navigation.settings',
    icon: { kind: 'uiicon', name: 'settings', variant: 'solid', size: 'l' },
    items: [
      { key: 'profile', path: 'profile', labelKey: 'navigation.profile' },
      { key: 'integration', path: 'integration', labelKey: 'navigation.integration' },
      {
        key: 'logout',
        type: 'static',
        labelKey: 'navigation.logout',
        path: '',
        subSection: 'actions',
        icon: { kind: 'component', component: Logout },
        onClick: () => {
          void logout()
        },
      },
    ],
  },
]
